import styled from 'styled-components';

export const Container = styled.div<{ isZero?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0.5rem 0rem;
  /* border: 1px solid red; */
  ${({ isZero }) =>
    isZero
      ? `
    justify-content: center;
    margin: auto;
  `
      : ''}

  img {
    margin-bottom: 1rem;
    width: 10rem;
  }

  h3 {
    margin-bottom: 1rem;
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.tertiary};
  }

  p {
    font-size: 0.875rem;
    margin-bottom: 1rem;
    /* border: 1px solid blue; */
    /* padding-inline: 1rem; */
  }
`;
